import { render, staticRenderFns } from "./ListOfUsers.vue?vue&type=template&id=4c89a06e&scoped=true"
import script from "./ListOfUsers.vue?vue&type=script&lang=js"
export * from "./ListOfUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89a06e",
  null
  
)

export default component.exports